import React, { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { PageOutletSuspense } from '../components/common/PageOutletSuspense';
import { Footer } from '../components/home/Footer';
import Navbar from '../components/header/Navbar';
import { useAppSelector } from '../hooks/useAppSelector';
import { AccountSheetProvider } from '../contexts/AccountSheetContext';
import { NavPersonaProvider } from '../contexts/NavPersonaContext';

const AccountMobileSheet = lazy(() =>
  import('../components/header/AccountMobileSheet').then((m) => ({
    default: m.AccountMobileSheet,
  })),
);

const MainLayout: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const isCartPage = location.pathname === '/cart';
  const designToolOld = location.pathname === '/design-tool2';
  const designTool = location.pathname === '/design-tool';
  const designPreview = location.pathname === '/design-preview';

  const isHomePage = location.pathname === '/';
  const isShopPage = location.pathname.startsWith('/shop');
  const isPdpPage = location.pathname.startsWith('/product/');
  const publicSelfSpacedPaths = [
    '/about',
    '/contact',
    '/track-order',
    '/shipping',
    '/size-guide',
    '/terms',
    '/privacy',
    '/refunds',
  ];
  const isPublicSelfSpacedPage = publicSelfSpacedPaths.includes(
    location.pathname,
  );
  const isFullscreenEditorShell =
    designTool || designToolOld || designPreview;

  const mainPaddingTop = isPdpPage
    ? 'lg:pt-16'
    : isHomePage ||
        isCartPage ||
        isShopPage ||
        isPublicSelfSpacedPage ||
        isFullscreenEditorShell
      ? ''
      : 'pt-12 md:pt-16';

  return (
    <AccountSheetProvider>
      <NavPersonaProvider
        isAuthenticated={isAuthenticated}
        user={user}
      >
        <div className="flex flex-col min-h-screen">
          <Navbar
            isCartPage={isCartPage || designTool}
            designPreview={designPreview}
          />
          <Suspense fallback={null}>
            <AccountMobileSheet />
          </Suspense>

          <main className={`flex-grow ${mainPaddingTop}`}>
            <PageOutletSuspense />
          </main>

          <Footer />
        </div>
      </NavPersonaProvider>
    </AccountSheetProvider>
  );
};

export default MainLayout;
